import React, { useState } from "react";
import ReactGA from "react-ga";
import "./HeaderSection.styl";

interface IHeaderProps {
  logoImageSrc: string;
  logoAlt: string;
  userName: string;
  userIcon?: React.ReactNode;
  settingIcon?: React.ReactNode;
}

const HeaderSection: React.FunctionComponent<IHeaderProps> = ({
  logoImageSrc = "",
  logoAlt = "",
  userIcon = null,
  userName = "Anonymous",
  settingIcon = null,
}) => {
  const [isProfileOpen, setProfileOpen] = useState(false); // 🚀 상태 추가

  const handleLogoClick = (e: React.MouseEvent) => {
    ReactGA.event({
      category: "Sample file",
      action: "Download sample file",
    });
  };

  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
  };

  const toggleProfile = () => {
    setProfileOpen((prev) => !prev); // 🚀 프로필 토글
  };

  return (
    <div className="header" onContextMenu={handleContextMenu}>
      <div className="clearfix">
        <a
          href="http://iaidimage.co.kr/"
          target="#"
          className="brand pull-left nodrag noselect"
          onClick={handleLogoClick}
        >
          <div className="main-logo">
            <img src={logoImageSrc} alt={logoAlt} draggable={false} />
          </div>
        </a>
        <div className="header-menu pull-right noselect nodrag ">
          {userIcon}
          <span className="user-name">{userName}</span>
          <span onClick={toggleProfile} className="setting-icon">
            {settingIcon}
          </span>

          {/* 🚀 프로필 팝업 추가 */}
          {isProfileOpen && (
            <div className="profile-popup">
              <p className="profile-email">{userName}</p>
              <button className="profile-btn">PROFILE</button>
              <button className="profile-btn">ACCOUNT</button>
              <button className="profile-btn">CHARGE</button>
              <div className="profile-credit">
                <span>ⓘ</span> <span>0 Credit</span>
              </div>
              <button className="sign-out-btn">Sign Out</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
